import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { parse, stringify } from '../../../util/urlHelpers';
import { InlineTextButton } from '../../Button/Button';

import classNames from 'classnames';
import DropdownMultiEnum from '../../DropdownMultiEnum/DropdownMultiEnum';
import css from './DropdownFilterEnum.module.css';

const DropdownFilterEnum = props => {
  const {
    options,
    onChange,
    onValueReset,
    label,
    searchParamName,
    placeholder,
    customIcon,
    className,
    dropdownInputClassName,
  } = props;

  const location = useLocation();
  const { pathname, search, state } = location;
  const history = useHistory();
  const searchValue = parse(search)[searchParamName];

  const value = Array.isArray(searchValue)
    ? searchValue
    : typeof searchValue === 'string'
    ? [searchValue]
    : [];

  const handleValueChanged = value => {
    const parsedSearch = parse(search);
    const { page, ...rest } = parsedSearch;
    const searchString = `?${stringify({ ...rest, [searchParamName]: value })}`;

    history.push(`${pathname}${searchString}`, state);
    onChange?.(value, searchString);
  };
  return (
    <div className={classNames(css.root, className)}>
      {label && <label>{label}</label>}
      <DropdownMultiEnum
        className={css.dropdown}
        options={options}
        value={value}
        onChange={handleValueChanged}
        placeholder={placeholder}
        disabled={!options?.length}
        dropdownInputClassName={classNames(css.input, dropdownInputClassName)}
        customIcon={customIcon}
      />
      {value?.length > 0 && (
        <InlineTextButton
          className={css.resetBtn}
          type="button"
          onClick={() => {
            handleValueChanged([]);
            onValueReset?.();
          }}
        >
          <FormattedMessage id="Global.resetFilter" />
        </InlineTextButton>
      )}
    </div>
  );
};

export default DropdownFilterEnum;
